/**
 * Mission Editor Store
 *
 * Convenience factory that creates a MissionsSlice store pre-loaded with
 * a default mission, suitable for testing or simple standalone use.
 *
 * @packageDocumentation
 */

import { create } from "zustand";

import { createMissionsSlice } from "./createMissionsSlice";
import { createDefaultMissionSpec } from "./utils";

import type { MissionsSlice } from "./createMissionsSlice";

/**
 * Store type for standalone editor use
 */
export type MissionEditorStore = MissionsSlice;

/**
 * Create a standalone mission editor store
 *
 * Creates a MissionsSlice store and pre-loads a default mission via loadMission.
 *
 * @example
 * ```typescript
 * const store = createMissionEditorStore();
 * store.getState().loadMission(someMission);
 * const current = store.getState().missions[store.getState().currentMissionId!];
 * expect(current.spec).toBe(someMission);
 * ```
 */
export function createMissionEditorStore() {
  const store = create<MissionEditorStore>()((set, get, api) => ({
    ...createMissionsSlice(set, get, api),
  }));

  store.getState().loadMission(createDefaultMissionSpec());

  return store;
}
